/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState,useEffect,useRef  } from "react";
import ReactDOM from "react-dom";
import axios from 'axios';
// reactstrap components
import { Container, Row, Col } from "reactstrap";
import { Table } from 'reactstrap';
import { Button } from "reactstrap";
import { Modal, ModalHeader, ModalBody, Input } from 'reactstrap';
import { connect } from 'react-redux';
import {setProducts} from '../../actions/quote'
import { API_URL } from"../../network"
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { positionList } from "../../config"
import moment from "moment";

import "react-virtualized/styles.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";
// index page sections
// import Hero from "./IndexSections/Hero.js";
// import Buttons from "./IndexSections/Buttons.js";
// import Inputs from "./IndexSections/Inputs.js";
// import CustomControls from "./IndexSections/CustomControls.js";
// import Menus from "./IndexSections/Menus.js";
// import Navbars from "./IndexSections/Navbars.js";
// import Tabs from "./IndexSections/Tabs.js";
// import Progress from "./IndexSections/Progress.js";
// import Pagination from "./IndexSections/Pagination.js";
// import Pills from "./IndexSections/Pills.js";
// import Labels from "./IndexSections/Labels.js";
// import Alerts from "./IndexSections/Alerts.js";
// import Typography from "./IndexSections/Typography.js";
// import Datepicker from "./IndexSections/Datepicker.js";
// import TooltipPopover from "./IndexSections/TooltipPopover.js";
// import Carousel from "./IndexSections/Carousel.js";
// import Icons from "./IndexSections/Icons.js";
// import Login from "./IndexSections/Login.js";
// import Download from "./IndexSections/Download.js";
import { Tooltip } from 'reactstrap';
import LoadingOverlay from 'react-loading-overlay';
import ScaleLoader from 'react-spinners/ScaleLoader'
import { toast } from 'react-toastify';
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.css';
import InnerImageZoom from 'react-inner-image-zoom';
import { Document, Page, pdfjs  } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const OtherPositionLabels = () => ({
  emb: "",
  screen_print: "",
  digital: "",
  vinyl: ""
});

const getOtherPositionLabels = (value) => {
  if(!value){
    return OtherPositionLabels();
  }

  try{
    const labels = JSON.parse(value);
    if(labels && typeof labels === 'object' && !Array.isArray(labels)){
      return {...OtherPositionLabels(), ...labels};
    }
  }
  catch(e){}
  return {
    emb: value,
    screen_print: value,
    digital: value,
    vinyl: value
  };
};

function Index(props) {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [uploadingFile, setUploadingFile] = useState(false);
  const [delettingFile, setDeletingFile] = useState(false);
  const [tableData1, setTableData1] = useState([]);
  const [tableData2, setTableData2] = useState([]);
  const [tableData3, setTableData3] = useState([]);
  const [tableData4, setTableData4] = useState([]);
  const [curSrc, setCurSrc] = useState(null);
  const [openPreview, setOpenPreview] = useState(false)
  const fileRef1 = useRef(null);
  const fileRef2 = useRef(null);
  const fileRef3 = useRef(null);
  const fileRef4 = useRef(null);
  const otherTextRef = useRef(OtherPositionLabels());
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [pdfScale, setPdfScale] = useState(0.8);
  const [otherText, setOtherText] = useState(OtherPositionLabels);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const updateOtherText=(productionType, value)=>{    
    const updatedOtherText = {
      ...otherTextRef.current,
      [productionType]: value
    };
    otherTextRef.current = updatedOtherText;
    setOtherText(updatedOtherText);

    if(props.selectedUser){
      var bodyFormData = new FormData();
      bodyFormData.append('other', JSON.stringify(updatedOtherText));
      axios.post(`/setting/setbyuserid/${props.selectedUser}`, bodyFormData).then(res => {
        if(res.data.status == "success"){        
        }
        else{
          toast.error("Failed to set other text");
        }
      }).catch(err => {
        toast.error('Failed to set other text');
      })
    }
    // setOtherText(value)
  }

  useEffect(() => {
    if(props.selectedUser){
      axios.get(`/setting/getbyuserid/${props.selectedUser}`).then(res => {
        if(res.data.status == "success")
          var setting = res.data.data
          const savedOtherText = getOtherPositionLabels(setting && setting.other);
          otherTextRef.current = savedOtherText;
          setOtherText(savedOtherText);
      }) 
      getData(props.selectedUser);
    }
  },[props.selectedUser]);

  const getListStyle = isDraggingOver => ({
    background: isDraggingOver ? "lightblue" : "white",
    padding: 0,
    width: '100%',
    // borderBottom: '6px solid #091E3F',
    minHeight:'50px',
    // marginBottom:'20px'
  });

  const getItemStyle = (isDragging, draggableStyle, index, itemType="product") => {
    var background = isDragging ? "lightgreen" : (index%2==0?"white":"#EDECEF");
    if(itemType == "discount" || itemType == "delivery" || itemType == "decoration"){
      background = '#C9E1E7';
    }
    else if(itemType == "task"){
      background = '#F6E7A3';
    }
    else if(itemType == "task_nav"){
      background = '#AA9331';
    }
    return(
      {
        // some basic styles to make the items look a bit nicer
        userSelect: "none",
        padding: '0 5px',
        margin: `0 0 0 0`,
        fontSize:'13.5px',
        // change background colour if dragging
        background: background,
        display:'flex',
        width:'100%',
        // styles we need to apply on draggables
        ...draggableStyle
      }
    );
  }

  const onDragEnd1 = (result)=> {
    const { source, destination } = result;
    // dropped outside the list
    if (!destination) {
      return;
    }
    // const sInd = +source.droppableId;
    // const dInd = +destination.droppableId;

    // if (sInd === dInd) {
      var new_tableData = reorder(tableData1, source.index, destination.index);
      setTableData1(new_tableData);

      var row = tableData1[source.index]
      if(row){
        var bodyFormData = new FormData();      
        bodyFormData.append('sort_order', destination.index);             
        axios.post(`/productions/edit/${row['id']}`, bodyFormData).then(res => {
          const result = res.data;      
          if(result.status == "success"){        
          }
          else{
            toast.error(result.data);
          }
        }).catch(err => {     
          toast.error('Something was wrong. Try again');
        })
      }
    // } 
  }
  
  const onDragEnd2 = (result)=> {
    const { source, destination } = result;
    // dropped outside the list
    if (!destination) {
      return;
    }
    // const sInd = +source.droppableId;
    // const dInd = +destination.droppableId;

    // if (sInd === dInd) {
      var new_tableData = reorder(tableData2, source.index, destination.index);
      setTableData2(new_tableData);

      var row = tableData2[source.index]
      if(row){
        var bodyFormData = new FormData();      
        bodyFormData.append('sort_order', destination.index);             
        axios.post(`/productions/edit/${row['id']}`, bodyFormData).then(res => {
          const result = res.data;      
          if(result.status == "success"){        
          }
          else{
            toast.error(result.data);
          }
        }).catch(err => {     
          toast.error('Something was wrong. Try again');
        })
      }
    // } 
  }

  
  const onDragEnd3 = (result)=> {
    const { source, destination } = result;
    // dropped outside the list
    if (!destination) {
      return;
    }
    // const sInd = +source.droppableId;
    // const dInd = +destination.droppableId;

    // if (sInd === dInd) {
      var new_tableData = reorder(tableData3, source.index, destination.index);
      setTableData3(new_tableData);

      var row = tableData3[source.index]
      if(row){
        var bodyFormData = new FormData();      
        bodyFormData.append('sort_order', destination.index);             
        axios.post(`/productions/edit/${row['id']}`, bodyFormData).then(res => {
          const result = res.data;      
          if(result.status == "success"){        
          }
          else{
            toast.error(result.data);
          }
        }).catch(err => {     
          toast.error('Something was wrong. Try again');
        })
      }
    // } 
  }

  
  const onDragEnd4 = (result)=> {
    const { source, destination } = result;
    // dropped outside the list
    if (!destination) {
      return;
    }
    // const sInd = +source.droppableId;
    // const dInd = +destination.droppableId;

    // if (sInd === dInd) {
      var new_tableData = reorder(tableData4, source.index, destination.index);
      setTableData4(new_tableData);

      var row = tableData4[source.index]
      if(row){
        var bodyFormData = new FormData();      
        bodyFormData.append('sort_order', destination.index);             
        axios.post(`/productions/edit/${row['id']}`, bodyFormData).then(res => {
          const result = res.data;      
          if(result.status == "success"){        
          }
          else{
            toast.error(result.data);
          }
        }).catch(err => {     
          toast.error('Something was wrong. Try again');
        })
      }
    // } 
  }

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
  
    return result;
  };

  const changeEmb = (index, key, value)=>{
    console.log(index, key, value)
    var newTableData = [...tableData1]
    var row = {...newTableData[index], [key]: value}
    newTableData[index] = row;
    setTableData1(newTableData);
  }
  
  const onChangeItemPosition1 = (index, position_key, value)=>{
    var newTableData = [...tableData1]
    var row = {...newTableData[index]}
    var position
    if(!row['position']){
      position = {};
    }
    else{
      position = {...row['position']}
    }
    position[position_key] = value;
    row['position'] = position;
    newTableData[index] = row;
    setTableData1(newTableData);
  }

  
  const onChangeItemPosition2 = (index, position_key, value)=>{
    var newTableData = [...tableData2]
    var row = {...newTableData[index]}
    var position
    if(!row['position']){
      position = {};
    }
    else{
      position = {...row['position']}
    }
    position[position_key] = value;
    row['position'] = position;
    newTableData[index] = row;
    setTableData2(newTableData);
  }

  const onChangeItemPosition3 = (index, position_key, value)=>{
    var newTableData = [...tableData3]
    var row = {...newTableData[index]}
    var position
    if(!row['position']){
      position = {};
    }
    else{
      position = {...row['position']}
    }
    position[position_key] = value;
    row['position'] = position;
    newTableData[index] = row;
    setTableData3(newTableData);
  }

  const onChangeItemPosition4 = (index, position_key, value)=>{
    var newTableData = [...tableData4]
    var row = {...newTableData[index]}
    var position
    if(!row['position']){
      position = {};
    }
    else{
      position = {...row['position']}
    }
    position[position_key] = value;
    row['position'] = position;
    newTableData[index] = row;
    setTableData4(newTableData);
  }

  const changeScreenPrint = (index, key, value)=>{
    var newTableData = [...tableData2]
    var row = {...newTableData[index], [key]: value}
    newTableData[index] = row;
    setTableData2(newTableData);
  }
  
  const changeDigital = (index, key, value)=>{
    var newTableData = [...tableData3]
    var row = {...newTableData[index], [key]: value}
    newTableData[index] = row;
    setTableData3(newTableData);
  }

  
  const changeVinyl = (index, key, value)=>{
    var newTableData = [...tableData4]
    var row = {...newTableData[index], [key]: value}
    newTableData[index] = row;
    setTableData4(newTableData);
  } 

  const getData = (selectedUser)=>{
    const token = localStorage.getItem('token_bigbrand');    
    const user = localStorage.getItem('user_bigbrand');
    var role = ""
    if(user && user != undefined){
      var userinfo = JSON.parse(user)
      role = userinfo['role']
    }
    if(!selectedUser && role=="admin"){
      setTableData1([]);
      setTableData2([]); 
      setTableData3([]); 
      setTableData4([]); return;
    }
    axios.get(`/productions/index?userid=${selectedUser?selectedUser:''}`).then(res => {
      if(res.data.status == "success"){
        if(res.data.data){
          var data = res.data.data;
          for(var i = 0; i < data.length; i++){
            if(data[i]['position']){
              data[i]['position'] = JSON.parse(data[i]['position']);
            }
          }
          setTableData1(data.filter(item=>item.production_type=='emb'));
          setTableData2(data.filter(item=>item.production_type=='screen_print'));
          setTableData3(data.filter(item=>item.production_type=='digital'));
          setTableData4(data.filter(item=>item.production_type=='vinyl'));
        }
      }
    })    
  }

  const saveItem1 = (index)=>{
    var row = tableData1[index]
    if(row){
      var bodyFormData = new FormData();      
      bodyFormData.append('file_name', row['file_name']);  
      bodyFormData.append('size', row['size']);  
      bodyFormData.append('size_width', row['size_width']);  
      bodyFormData.append('size_height', row['size_height']);  
      bodyFormData.append('stitch_count', row['stitch_count']);  
      bodyFormData.append('colours', row['colours']);     
      bodyFormData.append('position', JSON.stringify(row['position']));             
      axios.post(`/productions/edit/${row['id']}`, bodyFormData).then(res => {
        const result = res.data;        
        setUploadingFile(false)
        if(result.status == "success"){        
          toast.success("Products have been updated");
          getData(props.selectedUser);
        }
        else{
          toast.error(result.data);
        }
      }).catch(err => {     
        setUploadingFile(false)
        toast.error('Something was wrong. Try again');
      })
    }
  }
  
  const saveItem2 = (index)=>{
    var row = tableData2[index]
    if(row){
      var bodyFormData = new FormData();
      bodyFormData.append('file_name', row['file_name']);  
      bodyFormData.append('size', row['size']);  
      bodyFormData.append('size_width', row['size_width']);  
      bodyFormData.append('size_height', row['size_height']);  
      bodyFormData.append('stitch_count', row['stitch_count']);  
      bodyFormData.append('colours', row['colours']);     
      bodyFormData.append('position', JSON.stringify(row['position']));       
      axios.post(`/productions/edit/${row['id']}`, bodyFormData).then(res => {
        const result = res.data;        
        setUploadingFile(false)
        if(result.status == "success"){        
          toast.success("Products have been updated");
          getData(props.selectedUser);
        }
        else{
          toast.error(result.data);
        }
      }).catch(err => {     
        setUploadingFile(false)
        toast.error('Something was wrong. Try again');
      })
    }
  }

  const saveItem3 = (index)=>{
    var row = tableData3[index]
    if(row){
      var bodyFormData = new FormData();
      bodyFormData.append('file_name', row['file_name']);  
      bodyFormData.append('size', row['size']);  
      bodyFormData.append('size_width', row['size_width']);  
      bodyFormData.append('size_height', row['size_height']);  
      bodyFormData.append('stitch_count', row['stitch_count']);  
      bodyFormData.append('colours', row['colours']);     
      bodyFormData.append('position', JSON.stringify(row['position']));       
      axios.post(`/productions/edit/${row['id']}`, bodyFormData).then(res => {
        const result = res.data;        
        setUploadingFile(false)
        if(result.status == "success"){        
          toast.success("Products have been updated");
          getData(props.selectedUser);
        }
        else{
          toast.error(result.data);
        }
      }).catch(err => {     
        setUploadingFile(false)
        toast.error('Something was wrong. Try again');
      })
    }
  }

  const saveItem4 = (index)=>{
    var row = tableData4[index]
    if(row){
      var bodyFormData = new FormData();
      bodyFormData.append('file_name', row['file_name']);  
      bodyFormData.append('size', row['size']);  
      bodyFormData.append('size_width', row['size_width']);  
      bodyFormData.append('size_height', row['size_height']);  
      bodyFormData.append('stitch_count', row['stitch_count']);  
      bodyFormData.append('colours', row['colours']);     
      bodyFormData.append('position', JSON.stringify(row['position']));       
      axios.post(`/productions/edit/${row['id']}`, bodyFormData).then(res => {
        const result = res.data;        
        setUploadingFile(false)
        if(result.status == "success"){        
          toast.success("Products have been updated");
          getData(props.selectedUser);
        }
        else{
          toast.error(result.data);
        }
      }).catch(err => {     
        setUploadingFile(false)
        toast.error('Something was wrong. Try again');
      })
    }
  }

  const toggletooltip = () => setTooltipOpen(!tooltipOpen);

  const onChangeFile=(e, production_type)=>{
    if(e.target.files[0]){
      // if(e.target.files[0].name.includes("'")){
      //   toast.error('File name is invalid');
      //   return
      // }
      setUploadingFile(true)
      var bodyFormData = new FormData();
      bodyFormData.append('production', e.target.files[0]);    
      bodyFormData.append('user_id', props.selectedUser);      
      bodyFormData.append('production_type', production_type);    
      axios.post(`/productions/add`, bodyFormData).then(res => {
        const result = res.data;        
        setUploadingFile(false)
        if(result.status == "success"){        
          toast.success("Products have been added");
          getData(props.selectedUser);
        }
        else{
          toast.error(result.data);
        }
      }).catch(err => {     
        setUploadingFile(false)
        toast.error('Something was wrong. Try again');
      }).finally(()=>{
          getData(props.selectedUser); 
      });
      e.target.value = null
    }
  }

  const deleteRow=(id)=>{        
    setDeletingFile(true)
    var bodyFormData = new FormData();   
    axios.post(`/productions/delete/${id}`, bodyFormData).then(res => {
      const result = res.data;        
      setDeletingFile(false)
      if(result.status == "success"){        
        toast.success("Your production has been deleted");
        getData(props.selectedUser);
      }
      else{
        toast.error(result.data);
      }
    }).catch(err => {     
      setDeletingFile(false)
      toast.error('Something was wrong. Try again');
    })
  }
  
  const renderEmbroidery = (row,  index, provided)=>{
    return (
      <>
        <div
          className="p-2 col-item"
          style={{
            width:'30px',
            textAlign:'center'
          }}
        >
          <i className="fa fa-times"
            style={{cursor:'pointer'}}
            onClick={() => {
              const newState = [...tableData1];
              newState.splice(index, 1);
              setTableData1(newState);
              deleteRow(row['id'])
            }}
          ></i>
        </div>
        <div
          className="p-2 col-item"
          style={{
            width:'30px',
            textAlign:'center'
          }}
        >
          <a href={`${API_URL}${row['file_path']}`} download target="_blank" ><i className="fa fa-folder-open"></i></a>
        </div>
        <div
          className="p-2 col-item"
          style={{
            width:'30px',
            textAlign:'center'
          }}
        >
          <span style={{cursor:"pointer"}} onClick={()=>{setCurSrc(`${API_URL}${row['file_path']}`); setOpenPreview(true)}} width="50px" height="50px"> <i className="fa fa-camera" aria-hidden="true"></i></span>
        </div>
        <div
          className="p-2 col-item"
          style={{
            width:'180px',
            textAlign:'center'
          }}
        >
          <Input type="text" value = {row?row['file_name']:""}  onChange={(e)=>{changeEmb(index, 'file_name', e.target.value)}}/>
        </div>
        <div
          className="p-2 col-item"
          style={{
            width:'150px',
            textAlign:'center'
          }}
        >
          { moment(row['created_at']).format('DD/MM/YYYY') }  
        </div>
        <div
          className="p-2 col-item"
          style={{
            width:80, display:'block'
          }}>
            <div>
              <Input type="text" value = {row?row['stitch_count']:""} onChange={(e)=>{changeEmb(index, 'stitch_count', e.target.value)}}/>
            </div>
        </div>
        <div
          className="p-2 col-item"
          style={{
            width:80, display:'block'
          }}>
            <div>
              <Input type="text" value = {row?row['size']:""}  onChange={(e)=>{changeEmb(index, 'size', e.target.value)}}/>
              {/* <Input type="text" value = {row?row['size_width']:""}  onChange={(e)=>{changeEmb(index, 'size_width', e.target.value)}}/> */}
            </div>
        </div>
        {/* <div
          className="p-2 col-item"
          style={{
            width:80, display:'block'
          }}>
            <div>
              <Input type="text" value = {row?row['size_height']:""}  onChange={(e)=>{changeEmb(index, 'size_height', e.target.value)}}/>
            </div>
        </div>       */}
        <div
          className="p-2 col-item"
          style={{
            width:250, display:'block'
          }}>
            <div>
              <Input type="text" value = {row?row['colours']:""} onChange={(e)=>{changeEmb(index, 'colours', e.target.value)}}/>
            </div>
        </div>
        <div
          className="p-2 d-flex col-item"
          style={{
            width:600
          }}>
            {
              positionList.map((position, PositionIndex) => (
                <>
                  <div className="text-center" style={{width:34}} key={`item-customCheck-${index}-${position}`}>
                    <div className="w-100 custom-checkbox">
                        <input
                          key={`item-customCheckInput-${index}-${position}`}
                          className="custom-control-input"
                          id={`item-customCheckInput-${index}-${position}`}
                          type="checkbox"
                          name="primary_set"
                          checked={row['position']&&row['position'][position]?row['position'][position]:false}
                          value={row['position']&&row['position'][position]?row['position'][position]:false}
                          onChange={(e)=>onChangeItemPosition1(index, position,(row['position']&&row['position'][position])?!row['position'][position]:true)}
                        />
                        <label className="custom-control-label vertical" htmlFor={`item-customCheckInput-${index}-${position}`}>
                        </label>
                      </div>
                  </div>
                </>
              ))
          }
        </div>     
        <div
          className="p-2 col-item"
          style={{
            width:'30px',
            textAlign:'center'
          }}
        >
          <span style={{cursor:"pointer"}} onClick={()=>{saveItem1(index)}} width="50px" height="50px"> <i className="fa fa-save" aria-hidden="true"></i></span>
        </div>
        <div    
          className="p-2 col-item"                          
          {...provided.dragHandleProps}
          style={{
            width:30
          }}><i className="fa fa-arrows" ></i>
        </div>
      </>
    )
  }
  
  const renderPrint = (row,  index, provided)=>{
    return (
      <>
        <div
          className="p-2 col-item"
          style={{
            width:'30px',
            textAlign:'center'
          }}
        >
          <i className="fa fa-times"
            style={{cursor:'pointer'}}
            onClick={() => {
              const newState = [...tableData2];
              newState.splice(index, 1);
              setTableData2(newState);              
              deleteRow(row['id'])
            }}
          ></i>
        </div>
        <div
          className="p-2 col-item"
          style={{
            width:'30px',
            textAlign:'center'
          }}
        >
          <a href={`${API_URL}${row['file_path']}`} download target="_blank" ><i className="fa fa-folder-open"></i></a>
        </div>
        <div
          className="p-2 col-item"
          style={{
            width:'30px',
            textAlign:'center'
          }}
        >
          <span style={{cursor:"pointer"}} onClick={()=>{setCurSrc(`${API_URL}${row['file_path']}`); setOpenPreview(true)}} width="50px" height="50px"> <i className="fa fa-camera" aria-hidden="true"></i></span>
        </div>
        <div
          className="p-2 col-item"
          style={{
            width:'180px',
            textAlign:'center'
          }}
        >
          <Input type="text" value = {row?row['file_name']:""} onChange={(e)=>{changeScreenPrint(index, 'file_name', e.target.value)}}/>
        </div>
        <div
          className="p-2 col-item"
          style={{
            width:'150px',
            textAlign:'center'
          }}
        >
          { moment(row['created_at']).format('DD/MM/YYYY') } 
        </div>
        <div
          className="p-2 col-item"
          style={{
            width:80, display:'block'
          }}>
           
        </div>  
        <div
          className="p-2 col-item"
          style={{
            width:80, display:'block'
          }}>
            <div>
              <Input type="text" value = {row?row['size']:""}  onChange={(e)=>{changeScreenPrint(index, 'size', e.target.value)}}/>
            </div>
        </div>  
         {/* <div
          className="p-2 col-item"
          style={{
            width:80, display:'block'
          }}>
            <div>
              <Input type="text" value = {row?row['size_width']:""}  onChange={(e)=>{changeScreenPrint(index, 'size_width', e.target.value)}}/>
            </div>
        </div>
        <div
          className="p-2 col-item"
          style={{
            width:80, display:'block'
          }}>
            <div>
              <Input type="text" value = {row?row['size_height']:""}  onChange={(e)=>{changeScreenPrint(index, 'size_height', e.target.value)}}/>
            </div>
        </div>  */}
        <div
          className="p-2 col-item"
          style={{
            width:250, display:'block'
          }}>
            <div>
              <Input type="text" value = {row?row['colours']:""} onChange={(e)=>{changeScreenPrint(index, 'colours', e.target.value)}}/>
            </div>
        </div>
        {/* <div
          className="p-2 col-item"
          style={{
            width:160, display:'block'
          }}>
        </div> */}
        <div
          className="p-2 d-flex col-item"
          style={{
            width:600
          }}>
            {
              positionList.map((position, PositionIndex) => (
                <>
                  <div className="text-center" style={{width:34}} key={`item-customCheck-${index}-${position}`}>
                    <div className="w-100 custom-checkbox">
                        <input
                          key={`item-customCheckInput-${index}-${position}`}
                          className="custom-control-input"
                          id={`item-customCheckInput2-${index}-${position}`}
                          type="checkbox"
                          name="primary_set"
                          checked={row['position']&&row['position'][position]?row['position'][position]:false}
                          value={row['position']&&row['position'][position]?row['position'][position]:false}
                          onChange={(e)=>onChangeItemPosition2( index, position,(row['position']&&row['position'][position])?!row['position'][position]:true)}
                        />
                        <label className="custom-control-label vertical" htmlFor={`item-customCheckInput2-${index}-${position}`}>
                        </label>
                      </div>
                  </div>
                </>
              ))
          }
        </div>     
        <div
          className="p-2 col-item"
          style={{
            width:'30px',
            textAlign:'center'
          }}
        >
          <span style={{cursor:"pointer"}} onClick={()=>{saveItem2(index)}} width="50px" height="50px"> <i className="fa fa-save" aria-hidden="true"></i></span>
        </div>
        <div    
          className="p-2 col-item"                          
          {...provided.dragHandleProps}
          style={{
            width:30
          }}><i className="fa fa-arrows" ></i>
        </div>
      </>
    )
  }

  const renderDigital = (row,  index, provided)=>{
    return (
      <>
        <div
          className="p-2 col-item"
          style={{
            width:'30px',
            textAlign:'center'
          }}
        >
          <i className="fa fa-times"
            style={{cursor:'pointer'}}
            onClick={() => {
              const newState = [...tableData3];
              newState.splice(index, 1);
              setTableData3(newState);              
              deleteRow(row['id'])
            }}
          ></i>
        </div>
        <div
          className="p-2 col-item"
          style={{
            width:'30px',
            textAlign:'center'
          }}
        >
          <a href={`${API_URL}${row['file_path']}`} download target="_blank" ><i className="fa fa-folder-open"></i></a>
        </div>
        <div
          className="p-2 col-item"
          style={{
            width:'30px',
            textAlign:'center'
          }}
        >
          <span style={{cursor:"pointer"}} onClick={()=>{setCurSrc(`${API_URL}${row['file_path']}`); setOpenPreview(true)}} width="50px" height="50px"> <i className="fa fa-camera" aria-hidden="true"></i></span>
        </div>
        <div
          className="p-2 col-item"
          style={{
            width:'180px',
            textAlign:'center'
          }}
        >
          <Input type="text" value = {row?row['file_name']:""} onChange={(e)=>{changeDigital(index, 'file_name', e.target.value)}}/>
        </div>
        <div
          className="p-2 col-item"
          style={{
            width:'150px',
            textAlign:'center'
          }}
        >
          { moment(row['created_at']).format('DD/MM/YYYY') } 
        </div>
        <div
          className="p-2 col-item"
          style={{
            width:80, display:'block'
          }}>
           
        </div>  
        <div
          className="p-2 col-item"
          style={{
            width:80, display:'block'
          }}>
            <div>
              <Input type="text" value = {row?row['size_width']:""}  onChange={(e)=>{changeDigital(index, 'size_width', e.target.value)}}/>
            </div>
        </div>
        <div
          className="p-2 col-item"
          style={{
            width:80, display:'block'
          }}>
            <div>
              <Input type="text" value = {row?row['size_height']:""}  onChange={(e)=>{changeDigital(index, 'size_height', e.target.value)}}/>
            </div>
        </div>   
        <div
          className="p-2 col-item"
          style={{
            width:250, display:'block'
          }}>
            <div>
              <Input type="text" value = {row?row['colours']:""} onChange={(e)=>{changeDigital(index, 'colours', e.target.value)}}/>
            </div>
        </div>
        {/* <div
          className="p-2 col-item"
          style={{
            width:160, display:'block'
          }}>
        </div> */}
        <div
          className="p-2 d-flex col-item"
          style={{
            width:600
          }}>
            {
              positionList.map((position, PositionIndex) => (
                <>
                  <div className="text-center" style={{width:34}} key={`item-customCheck-${index}-${position}`}>
                    <div className="w-100 custom-checkbox">
                        <input
                          key={`item-customCheckInput-${index}-${position}`}
                          className="custom-control-input"
                          id={`item-customCheckInput3-${index}-${position}`}
                          type="checkbox"
                          name="primary_set"
                          checked={row['position']&&row['position'][position]?row['position'][position]:false}
                          value={row['position']&&row['position'][position]?row['position'][position]:false}
                          onChange={(e)=>onChangeItemPosition3( index, position,(row['position']&&row['position'][position])?!row['position'][position]:true)}
                        />
                        <label className="custom-control-label vertical" htmlFor={`item-customCheckInput3-${index}-${position}`}>
                        </label>
                      </div>
                  </div>
                </>
              ))
          }
        </div>     
        <div
          className="p-2 col-item"
          style={{
            width:'30px',
            textAlign:'center'
          }}
        >
          <span style={{cursor:"pointer"}} onClick={()=>{saveItem3(index)}} width="50px" height="50px"> <i className="fa fa-save" aria-hidden="true"></i></span>
        </div>
        <div    
          className="p-2 col-item"                          
          {...provided.dragHandleProps}
          style={{
            width:30
          }}><i className="fa fa-arrows" ></i>
        </div>
      </>
    )
  }  
  
  const renderVinyl = (row,  index, provided)=>{
    return (
      <>
        <div
          className="p-2 col-item"
          style={{
            width:'30px',
            textAlign:'center'
          }}
        >
          <i className="fa fa-times"
            style={{cursor:'pointer'}}
            onClick={() => {
              const newState = [...tableData3];
              newState.splice(index, 1);
              setTableData4(newState);              
              deleteRow(row['id'])
            }}
          ></i>
        </div>
        <div
          className="p-2 col-item"
          style={{
            width:'30px',
            textAlign:'center'
          }}
        >
          <a href={`${API_URL}${row['file_path']}`} download target="_blank" ><i className="fa fa-folder-open"></i></a>
        </div>
        <div
          className="p-2 col-item"
          style={{
            width:'30px',
            textAlign:'center'
          }}
        >
          <span style={{cursor:"pointer"}} onClick={()=>{setCurSrc(`${API_URL}${row['file_path']}`); setOpenPreview(true)}} width="50px" height="50px"> <i className="fa fa-camera" aria-hidden="true"></i></span>
        </div>
        <div
          className="p-2 col-item"
          style={{
            width:'180px',
            textAlign:'center'
          }}
        >
          <Input type="text" value = {row?row['file_name']:""} onChange={(e)=>{changeVinyl(index, 'file_name', e.target.value)}}/>
        </div>
        <div
          className="p-2 col-item"
          style={{
            width:'150px',
            textAlign:'center'
          }}
        >
          { moment(row['created_at']).format('DD/MM/YYYY') } 
        </div>
        <div
          className="p-2 col-item"
          style={{
            width:80, display:'block'
          }}>
           
        </div> 
        <div
          className="p-2 col-item"
          style={{
            width:80, display:'block'
          }}>
            <div>
              <Input type="text" value = {row?row['size']:""}  onChange={(e)=>{changeVinyl(index, 'size', e.target.value)}}/>
            </div>
        </div> 
        {/* <div
          className="p-2 col-item"
          style={{
            width:80, display:'block'
          }}>
            <div>
              <Input type="text" value = {row?row['size_width']:""}  onChange={(e)=>{changeVinyl(index, 'size_width', e.target.value)}}/>
            </div>
        </div>
        <div
          className="p-2 col-item"
          style={{
            width:80, display:'block'
          }}>
            <div>
              <Input type="text" value = {row?row['size_height']:""}  onChange={(e)=>{changeVinyl(index, 'size_height', e.target.value)}}/>
            </div>
        </div>   */}
        <div
          className="p-2 col-item"
          style={{
            width:250, display:'block'
          }}>
            <div>
              <Input type="text" value = {row?row['colours']:""} onChange={(e)=>{changeVinyl(index, 'colours', e.target.value)}}/>
            </div>
        </div>
        {/* <div
          className="p-2 col-item"
          style={{
            width:160, display:'block'
          }}>
        </div> */}
        <div
          className="p-2 d-flex col-item"
          style={{
            width:600
          }}>
            {
              positionList.map((position, PositionIndex) => (
                <>
                  <div className="text-center" style={{width:34}} key={`item-customCheck-${index}-${position}`}>
                    <div className="w-100 custom-checkbox">
                        <input
                          key={`item-customCheckInput-${index}-${position}`}
                          className="custom-control-input"
                          id={`item-customCheckInput4-${index}-${position}`}
                          type="checkbox"
                          name="primary_set"
                          checked={row['position']&&row['position'][position]?row['position'][position]:false}
                          value={row['position']&&row['position'][position]?row['position'][position]:false}
                          onChange={(e)=>onChangeItemPosition4( index, position,(row['position']&&row['position'][position])?!row['position'][position]:true)}
                        />
                        <label className="custom-control-label vertical" htmlFor={`item-customCheckInput4-${index}-${position}`}>
                        </label>
                      </div>
                  </div>
                </>
              ))
          }
        </div>     
        <div
          className="p-2 col-item"
          style={{
            width:'30px',
            textAlign:'center'
          }}
        >
          <span style={{cursor:"pointer"}} onClick={()=>{saveItem4(index)}} width="50px" height="50px"> <i className="fa fa-save" aria-hidden="true"></i></span>
        </div>
        <div    
          className="p-2 col-item"                          
          {...provided.dragHandleProps}
          style={{
            width:30
          }}><i className="fa fa-arrows" ></i>
        </div>
      </>
    )
  }
  var extension = null;
  if(curSrc)
    extension = curSrc.split('.').pop();
  var overlayText = "";
  if(delettingFile)
    overlayText = "Deleting Production...";
  if(uploadingFile)
    overlayText = "Uploading Production...";
  return (
    <>  
    {props.selectedUser&&  
      <Row className="">
        <Col md="12">
          <div className="p-3 bg-black d-flex justify-content-between align-items-center">
            <div>Embroidery</div>
            <div className="d-flex align-items-center">
              <Button onClick={()=>{fileRef1.current.click()}} className="rounded-0 pr-5 pl-5 yellow" color="primary" type="button">
                Upload
              </Button>
              <input type="file" ref={fileRef1} style={{display:'none'}} onChange={(e)=>onChangeFile(e, 'emb')}/>
              <span style={{fontSize:32}}  href="#" id="TooltipExample" className="material-icons">upload_file</span>
              {/* <p>Somewhere in here is a <span style={{textDecoration: "underline", color:"blue"}} href="#" id="TooltipExample">tooltip</span>.</p> */}
              <Tooltip placement="bottom" isOpen={tooltipOpen} className="text-left" target="TooltipExample" toggle={toggletooltip}>
                PDF/EPS required.<br/>
                *If you have a Production Style Guide, you can upload it here.<br/>
                *Jpegs & PNG are ok for reference only, but not suitable for production
              </Tooltip>
            </div>
          </div>
          <div className="product-table-header mt-1">
            <div
              className="p-2 col-item"
              style={{
                width:'96px',
                textAlign:'right'
              }}
            >
              View
            </div>
            <div
              className="p-2 col-item"
              style={{
                width:'180px',
                textAlign:'center'
              }}
            >
              File
            </div>
            <div
              className="p-2 col-item"
              style={{
                width:'150px',
                textAlign:'centlefter'
              }}
            >
              Date
            </div>
            <div
              className="p-2 col-item"
              style={{
                width:80, display:'block',
                textAlign:'center'
              }}>
                Stitch<br/>Count
            </div>
            <div
              className="p-2 col-item"
              style={{
                width:80, display:'block',
                textAlign:'center'
              }}>
                Size
            </div>  
            {/* <div
              className="p-2 col-item"
              style={{
                width:80, display:'block',
                textAlign:'center'
              }}>
                Size Width
            </div>   
            <div
              className="p-2 col-item"
              style={{
                width:80, display:'block',
                textAlign:'center'
              }}>
                Size Height
            </div>       */}
            <div
              className="p-2 col-item"
              style={{
                width:250, display:'block',
                textAlign:'center'
              }}>
                Colours
            </div>
            <div
              className="p-2 d-flex col-item"
              style={{
                width:600
              }}>
              {
                positionList.map((position, positionIndex) => (
                  <>
                    {position !="Other"?
                      <div className="text-center" style={{width:34}} key={positionIndex}>
                        <label className="position-label">{position}</label>
                      </div>:
                      <div className="d-block">
                        <Input className="other-input" maxLength={250} style={{width:75,  marginLeft:5}} type="text" name="other_position" value={otherText.emb} onChange={(e)=>updateOtherText('emb', e.target.value)}></Input>
                      </div>
                    }
                  </>
                )) 
              }     
            </div>     
            <div
              className="p-2 col-item"
              style={{
                width:'30px',
                textAlign:'center'
              }}
            >
            </div>
          </div>
          <DragDropContext onDragEnd={(e)=>{onDragEnd1(e);}}>
            <Droppable droppableId="droppable">
              {(provided, snapshot) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  style={getListStyle(snapshot.isDraggingOver)}
                >
                  {tableData1.map((item, index) => (
                    <Draggable key={item.id} draggableId={`${item.id}`} index={index}>
                      {(provided, snapshot) => (
                        <div
                          className="product-row"
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          // {...provided.dragHandleProps}
                          style={getItemStyle(
                            snapshot.isDragging,
                            provided.draggableProps.style,
                            index
                          )}
                        >
                          {renderEmbroidery(item,  index, provided)}
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </Col>
        <Col md="12" style={{marginTop:30}}>
          <div className="p-3 bg-black d-flex justify-content-between align-items-center">
            <div>Screen Print</div>
            <div className="d-flex align-items-center">
              <Button onClick={()=>{fileRef2.current.click()}} className="rounded-0 pr-5 pl-5 yellow" color="primary" type="button">
                Upload
              </Button>
              <input type="file" ref={fileRef2} style={{display:'none'}} onChange={(e)=>onChangeFile(e, 'screen_print')}/>
              <span style={{fontSize:32}}  href="#" id="TooltipExample" className="material-icons">upload_file</span>
              {/* <p>Somewhere in here is a <span style={{textDecoration: "underline", color:"blue"}} href="#" id="TooltipExample">tooltip</span>.</p> */}
              <Tooltip placement="bottom" isOpen={tooltipOpen} className="text-left" target="TooltipExample" toggle={toggletooltip}>
                PDF/EPS required.<br/>
                *If you have a Production Style Guide, you can upload it here.<br/>
                *Jpegs & PNG are ok for reference only, but not suitable for production
              </Tooltip>
            </div>
          </div>
          <div className="product-table-header mt-1">
            <div className="p-2 col-item" style={{ width:'96px', textAlign:'right' }} >
              View
            </div>
            <div className="p-2 col-item" style={{ width:'180px', textAlign:'center' }} >
              File
            </div>
            <div className="p-2 col-item" style={{ width:'150px', textAlign:'centlefter' }} >
              Date
            </div>
            <div className="p-2 col-item" style={{ width:80, display:'block', textAlign:'center' }}> </div>
            <div className="p-2 col-item" style={{ width:80, display:'block', textAlign:'center' }}>
                Size
            </div>  
            {/* <div className="p-2 col-item" style={{ width:80, display:'block', textAlign:'center' }}>
                Size Width
            </div>  
            <div className="p-2 col-item" style={{ width:80, display:'block', textAlign:'center' }}>
                Size Height
            </div>   */}
            <div className="p-2 col-item" style={{ width:250, display:'block', textAlign:'center' }}>
                Colours
            </div>
            {/* <div className="p-2 col-item" style={{ width:136, display:'block', textAlign:'center' }}></div>       */}
            <div className="p-2 d-flex col-item" style={{ width:600 }}>
              {
                positionList.map((position, positionIndex) => (
                  <>
                    {position !="Other"?
                      <div className="text-center" style={{width:34}} key={positionIndex}>
                        <label className="position-label">{position}</label>
                      </div>:
                      <div className="d-block">
                        <Input className="other-input" maxLength={250} style={{width:75,  marginLeft:5}} type="text" name="other_position" value={otherText.screen_print} onChange={(e)=>updateOtherText('screen_print', e.target.value)}></Input>
                      </div>
                    }
                  </>
                )) 
              }     
            </div>     
            <div className="p-2 col-item" style={{ width:'30px', textAlign:'center' }} > </div>
          </div>
          <DragDropContext onDragEnd={(e)=>{onDragEnd2(e);}}>
            <Droppable droppableId="droppable">
              {(provided, snapshot) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  style={getListStyle(snapshot.isDraggingOver)}
                >
                  {tableData2.map((item, index) => (
                    <Draggable key={item.id} draggableId={`${item.id}`} index={index}>
                      {(provided, snapshot) => (
                        <div
                          className="product-row"
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          // {...provided.dragHandleProps}
                          style={getItemStyle(
                            snapshot.isDragging,
                            provided.draggableProps.style,
                            index
                          )}
                        >
                          {renderPrint(item,  index, provided)}
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </Col>
        <Col md="12" style={{marginTop:30}}>
          <div className="p-3 bg-black d-flex justify-content-between align-items-center">
            <div>Digital Print</div>
            <div className="d-flex align-items-center">
              <Button onClick={()=>{fileRef3.current.click()}} className="rounded-0 pr-5 pl-5 yellow" color="primary" type="button">
                Upload
              </Button>
              <input type="file" ref={fileRef3} style={{display:'none'}} onChange={(e)=>onChangeFile(e, 'digital')}/>
              <span style={{fontSize:32}}  href="#" id="TooltipExample" className="material-icons">upload_file</span>
              {/* <p>Somewhere in here is a <span style={{textDecoration: "underline", color:"blue"}} href="#" id="TooltipExample">tooltip</span>.</p> */}
              <Tooltip placement="bottom" isOpen={tooltipOpen} className="text-left" target="TooltipExample" toggle={toggletooltip}>
                PDF/EPS required.<br/>
                *If you have a Production Style Guide, you can upload it here.<br/>
                *Jpegs & PNG are ok for reference only, but not suitable for production
              </Tooltip>
            </div>
          </div>
          <div className="product-table-header mt-1">
            <div className="p-2 col-item" style={{ width:'96px', textAlign:'right' }} >
              View
            </div>
            <div className="p-2 col-item" style={{ width:'180px', textAlign:'center' }} >
              File
            </div>
            <div className="p-2 col-item" style={{ width:'150px', textAlign:'centlefter' }} >
              Date
            </div>
           <div className="p-2 col-item" style={{ width:80, display:'block', textAlign:'center' }}></div>  
            <div
              className="p-2 col-item"
              style={{
                width:80, display:'block',
                textAlign:'center'
              }}>
                Size Width
            </div>  
            <div
              className="p-2 col-item"
              style={{
                width:80, display:'block',
                textAlign:'center'
              }}>
                Size Height
            </div>
            <div
              className="p-2 col-item"
              style={{
                width:250, display:'block',
                textAlign:'center'
              }}>
                Colours
            </div>
            {/* <div
              className="p-2 col-item"
              style={{
                width:136, display:'block',
                textAlign:'center'
              }}>
            </div>       */}
            <div
              className="p-2 d-flex col-item"
              style={{
                width:600
              }}>
              {
                positionList.map((position, positionIndex) => (
                  <>
                    {position !="Other"?
                      <div className="text-center" style={{width:34}} key={positionIndex}>
                        <label className="position-label">{position}</label>
                      </div>:
                      <div className="d-block">
                        <Input className="other-input" maxLength={250} style={{width:75,  marginLeft:5}} type="text" name="other_position" value={otherText.digital} onChange={(e)=>updateOtherText('digital', e.target.value)}></Input>
                      </div>
                    }
                  </>
                )) 
              }     
            </div>     
            <div
              className="p-2 col-item"
              style={{
                width:'30px',
                textAlign:'center'
              }}
            >
            </div>
          </div>
          <DragDropContext onDragEnd={(e)=>{onDragEnd3(e);}}>
            <Droppable droppableId="droppable">
              {(provided, snapshot) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  style={getListStyle(snapshot.isDraggingOver)}
                >
                  {tableData3.map((item, index) => (
                    <Draggable key={item.id} draggableId={`${item.id}`} index={index}>
                      {(provided, snapshot) => (
                        <div
                          className="product-row"
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          // {...provided.dragHandleProps}
                          style={getItemStyle(
                            snapshot.isDragging,
                            provided.draggableProps.style,
                            index
                          )}
                        >
                          {renderDigital(item,  index, provided)}
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </Col>
        
        <Col md="12" style={{marginTop:30}}>
          <div className="p-3 bg-black d-flex justify-content-between align-items-center">
            <div>Vinyl Print</div>
            <div className="d-flex align-items-center">
              <Button onClick={()=>{fileRef4.current.click()}} className="rounded-0 pr-5 pl-5 yellow" color="primary" type="button">
                Upload
              </Button>
              <input type="file" ref={fileRef4} style={{display:'none'}} onChange={(e)=>onChangeFile(e, 'vinyl')}/>
              <span style={{fontSize:32}}  href="#" id="TooltipExample" className="material-icons">upload_file</span>
              {/* <p>Somewhere in here is a <span style={{textDecoration: "underline", color:"blue"}} href="#" id="TooltipExample">tooltip</span>.</p> */}
              <Tooltip placement="bottom" isOpen={tooltipOpen} className="text-left" target="TooltipExample" toggle={toggletooltip}>
                PDF/EPS required.<br/>
                *If you have a Production Style Guide, you can upload it here.<br/>
                *Jpegs & PNG are ok for reference only, but not suitable for production
              </Tooltip>
            </div>
          </div>
          <div className="product-table-header mt-1">
            <div
              className="p-2 col-item"
              style={{
                width:'96px',
                textAlign:'right'
              }}
            >
              View
            </div>
            <div
              className="p-2 col-item"
              style={{
                width:'180px',
                textAlign:'center'
              }}
            >
              File
            </div>
            <div
              className="p-2 col-item"
              style={{
                width:'150px',
                textAlign:'centlefter'
              }}
            >
              Date
            </div>
            <div
              className="p-2 col-item"
              style={{
                width:80, display:'block',
                textAlign:'center'
              }}>
            </div>  
            <div
              className="p-2 col-item"
              style={{
                width:80, display:'block',
                textAlign:'center'
              }}>
                Size
            </div>  
            {/* <div
              className="p-2 col-item"
              style={{
                width:80, display:'block',
                textAlign:'center'
              }}>
                Size Width
            </div>  
            <div
              className="p-2 col-item"
              style={{
                width:80, display:'block',
                textAlign:'center'
              }}>
                Size Height
            </div>   */}
            <div
              className="p-2 col-item"
              style={{
                width:250, display:'block',
                textAlign:'center'
              }}>
                Colours
            </div>
            {/* <div
              className="p-2 col-item"
              style={{
                width:136, display:'block',
                textAlign:'center'
              }}>
            </div>       */}
            <div
              className="p-2 d-flex col-item"
              style={{
                width:600
              }}>
              {
                positionList.map((position, positionIndex) => (
                  <>
                    {position !="Other"?
                      <div className="text-center" style={{width:34}} key={positionIndex}>
                        <label className="position-label">{position}</label>
                      </div>:
                      <div className="d-block">
                        <Input className="other-input" maxLength={250} style={{width:75,  marginLeft:5}} type="text" name="other_position" value={otherText.vinyl} onChange={(e)=>updateOtherText('vinyl', e.target.value)}></Input>
                      </div>
                    }
                  </>
                )) 
              }     
            </div>     
            <div
              className="p-2 col-item"
              style={{
                width:'30px',
                textAlign:'center'
              }}
            >
            </div>
          </div>
          <DragDropContext onDragEnd={(e)=>{onDragEnd4(e);}}>
            <Droppable droppableId="droppable">
              {(provided, snapshot) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  style={getListStyle(snapshot.isDraggingOver)}
                >
                  {tableData4.map((item, index) => (
                    <Draggable key={item.id} draggableId={`${item.id}`} index={index}>
                      {(provided, snapshot) => (
                        <div
                          className="product-row"
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          // {...provided.dragHandleProps}
                          style={getItemStyle(
                            snapshot.isDragging,
                            provided.draggableProps.style,
                            index
                          )}
                        >
                          {renderVinyl(item,  index, provided)}
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </Col>
      </Row>
    }
    <Modal isOpen={openPreview} toggle={()=>setOpenPreview(false)} >
        <ModalHeader toggle={()=>setOpenPreview(false)}>Preview</ModalHeader>
        <ModalBody>          
          <div className="resource-preview-container">
            <div className="resource-preview">
            {extension && ( extension.toLowerCase().includes("jpg") || extension.toLowerCase().includes("png") || extension.toLowerCase().includes("jpeg") || extension.toLowerCase().includes("gif") ) &&
                <InnerImageZoom src={curSrc} zoomSrc={curSrc} /> 
              }
              {extension && ( extension.includes("pdf")) &&
              <div>
                <Document file={curSrc} onLoadSuccess={onDocumentLoadSuccess}>
                  <Page scale={pdfScale} pageNumber={pageNumber} />
                </Document>
              </div>
              }
            </div>
            {curSrc &&extension && ( extension.includes("pdf")) &&
            <div className="d-flex justify-content-between">
              <a href={curSrc} download target="_blank" ><i className="fa fa-folder-open"></i></a>
              <div>
                <i className="fa fa-search-minus mr-3" style={{cursor:'pointer'}} onClick={()=>{  setPdfScale(pdfScale*0.8)}}></i>
                <i className="fa fa-search-plus mr-3" style={{cursor:'pointer'}} onClick={()=>{ setPdfScale(pdfScale*1.2)}}></i>
                <i className="fa fa-chevron-left mr-3" style={{cursor:'pointer'}} onClick={()=>{ if(pageNumber>1) setPageNumber(pageNumber-1)}}></i>
                <span className="mr-3" style={{fontSize:14}}>Page {pageNumber} of {numPages}</span>
                <i className="fa fa-chevron-right" style={{cursor:'pointer'}} onClick={()=>{ if(pageNumber<numPages) setPageNumber(pageNumber+1)}} ></i>
              </div>
            </div>
            }
          </div>
        </ModalBody>
      </Modal>
      <LoadingOverlay
        active={uploadingFile||delettingFile}
        styles={{
            overlay: (base) => ({
            ...base,
            fontSize:'18px',
            color: 'rgb(5, 37, 51)',
            background: 'rgb(60 60 60 / 48%)',
            position:'fixed',
            zIndex:1000000000
            })
        }}
        spinner = {<ScaleLoader color={'#1976d2'} radius={2.5} margin={2.5} height={40} width={5}/>}
        // spinner
        // text='Loading ...'
        >
      </LoadingOverlay>
    </>
  );
}


const mapStateToProps = (state) => {
  return {
    quote: state.quote,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    setProducts: products=>dispatch(setProducts(products)),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Index);
